// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"57":"78b3b3dd","64":"022f031b","262":"37707d54","309":"47ae1f7c","507":"427dbb3b"}[chunkId] + ".chunk.css";
};